module.exports = function(obj) {
obj || (obj = {});
var __t, __p = '', __e = _.escape, __j = Array.prototype.join;
function print() { __p += __j.call(arguments, '') }
with (obj) {

 if (confirm) { ;
__p += '\n    <div class="stack-step">\n        <h2>\n            Check your\n            ';
 if (isMobile) { ;
__p += 'phone';
 } else { ;
__p += 'email';
 } ;
__p += '\n            for a link to reset your password\n        </h2>\n        <span class="user-id">' +
__e( (isMobile) ? phone : email ) +
'</span>\n        <p>\n            You should be getting\n            ';
 if (isMobile) { ;
__p += 'a text message';
 } else { ;
__p += 'an email';
 } ;
__p += '\n            right about... <b>now</b>.\n            Click on the link and follow the instructions to\n            reset your password.\n        </p>\n    </div>\n';
 } else if (handle) { ;
__p += '\n    <div class="stack-step">\n        <h1>Forgot password?</h1>\n        <span class="subtitle user-id">' +
__e( handle ) +
'</span>\n        <p>\n            How would you like to receive your link to reset your password?\n        </p>\n        <div class="choice-actions">\n            <a class="auth-choice';
 if (!phone) { ;
__p += ' disabled';
 } ;
__p += '" data-mobile="1" href="#">\n                Text me the link\n                <span>*</span>\n            </a>\n            <a class="auth-choice" data-mobile="0" href="#">Email me the link</a>\n        </div>\n        <span class="notice">\n            * Msg &amp; Data rates may apply.\n        </span>\n    </div>\n';
 } else { ;
__p += '\n    <div class="login-container">\n        <h1>Forgot password?</h1>\n        <span class="subtitle">\n            Let\'s look up your account\n        </span>\n        <div class="handle-component"></div>\n    </div>\n';
 } ;
__p += '\n';

}
return __p
}